import React from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

type AppLanguage = 'es' | 'en' | 'ca' | 'gl' | 'eu';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: AppLanguage) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('appLanguage', lng);
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', mb: 2 }}>
      <Button
        variant={i18n.language.startsWith('es') ? 'contained' : 'outlined'}
        onClick={() => changeLanguage('es')}
      >
        ES
      </Button>
      <Button
        variant={i18n.language.startsWith('en') ? 'contained' : 'outlined'}
        onClick={() => changeLanguage('en')}
      >
        EN
      </Button>
      <Button
        variant={i18n.language.startsWith('ca') ? 'contained' : 'outlined'}
        onClick={() => changeLanguage('ca')}
      >
        CA
      </Button>
      <Button
        variant={i18n.language.startsWith('gl') ? 'contained' : 'outlined'}
        onClick={() => changeLanguage('gl')}
      >
        GL
      </Button>
      <Button
        variant={i18n.language.startsWith('eu') ? 'contained' : 'outlined'}
        onClick={() => changeLanguage('eu')}
      >
        EU
      </Button>
    </Box>
  );
};

export default LanguageSwitcher;
